import { Modal, PrimaryButton, SecondaryButton, toast } from '@systemeio/ui'
import { BlogPostId, BlogPostsInterface } from 'modules/blogs/types/blog-posts-interface'
import React, { useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { SchedulePostModal } from './schedule-post-modal'

export interface ActivatePostModalProps {
  opened: boolean
  onClose: () => void
  post: BlogPostsInterface
  onSchedulePost: (postId: BlogPostId, data: BlogPostsInterface) => void
  onChangeStatus: (blogPost: BlogPostsInterface) => void
}

export const ActivatePostModal = ({
  opened,
  onClose,
  post,
  onSchedulePost,
  onChangeStatus,
}: ActivatePostModalProps) => {
  const { t } = useLocoTranslation()

  const [openedSchedule, setOpenedSchedule] = useState<boolean>(false)
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const activatePost = async () => {
    setIsFetching(true)
    try {
      await onChangeStatus(post)
      onClose()
      toast.success(t('dashboard.blog.posts.activated'))
    } catch (e) {}
    setIsFetching(false)
  }

  return (
    <>
      <Modal
        isCentered
        opened={opened}
        onClose={onClose}
        title={t('dashboard.blog.posts.activate_modal.confirm')}
      >
        <div className="flex flex-col gap-6 lg:gap-10">
          <div className="flex justify-center">
            <p className="text-text-primary text-base">
              {t('dashboard.blog.posts.activate_modal.text')}
            </p>
          </div>
          <div className="flex justify-center gap-4">
            <SecondaryButton
              disabled={isFetching && !post}
              className="w-full"
              width="large"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault()
                setOpenedSchedule(true)
              }}
            >
              {t('dashboard.blog.posts.activate_modal.publish_later')}
            </SecondaryButton>
            <PrimaryButton
              isFetching={isFetching}
              disabled={!post}
              className="w-full"
              width="large"
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault()
                activatePost()
              }}
            >
              {t('dashboard.blog.posts.activate_modal.activate')}
            </PrimaryButton>
          </div>
        </div>
      </Modal>
      <SchedulePostModal
        opened={openedSchedule}
        onClose={() => setOpenedSchedule(false)}
        post={post}
        onSchedulePost={onSchedulePost}
      />
    </>
  )
}
